import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import ApiEnter from "@/api/ApiEnter";
import sweetalert from "sweetalert";
import DataRoaming from "@/data/AdminPanel/DataRoaming";
import ApiRoaming from "@/api/ApiRoaming";
let RoamingZoneCreate = class RoamingZoneCreate extends Vue {
    constructor() {
        super(...arguments);
        this.HasLoading = false;
        this.Breadcrumbs = DataRoaming.RoamingZoneCreateBreadcrumbs;
        this.newRoamingZone = {
            zone_name: "",
            zone_order: 10,
            group_1_call_price: 0,
            group_2_call_price: 0,
            group_3_call_price: 0,
            group_4_call_price: 0,
            group_5_call_price: 0,
            group_1_sms_price: 0,
            group_2_sms_price: 0,
            group_3_sms_price: 0,
            group_4_sms_price: 0,
            group_5_sms_price: 0,
            incoming_call_price: 0,
            data_mb_price: 0,
        };
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            console.log("newRoamingZone: ", this.newRoamingZone);
            if (this.newRoamingZone.zone_name == null ||
                this.newRoamingZone.zone_order == null || // или typeof this.newRoamingZone.zone_order !== 'number'
                this.newRoamingZone.group_1_call_price == null ||
                this.newRoamingZone.group_2_call_price == null ||
                this.newRoamingZone.group_3_call_price == null ||
                this.newRoamingZone.group_4_call_price == null ||
                this.newRoamingZone.group_5_call_price == null ||
                this.newRoamingZone.group_1_sms_price == null ||
                this.newRoamingZone.group_2_sms_price == null ||
                this.newRoamingZone.group_3_sms_price == null ||
                this.newRoamingZone.group_4_sms_price == null ||
                this.newRoamingZone.group_5_sms_price == null ||
                this.newRoamingZone.incoming_call_price == null ||
                this.newRoamingZone.data_mb_price == null) {
                throw new Error("Одно из свойства не заполнено");
            }
            const zone_uuid = await ApiRoaming.CreateRoamingZone(ApiEnter.CurrentSessionUUID, this.newRoamingZone.zone_name, Number(this.newRoamingZone.zone_order), Number(this.newRoamingZone.group_1_call_price), Number(this.newRoamingZone.group_2_call_price), Number(this.newRoamingZone.group_3_call_price), Number(this.newRoamingZone.group_4_call_price), Number(this.newRoamingZone.group_5_call_price), Number(this.newRoamingZone.group_1_sms_price), Number(this.newRoamingZone.group_2_sms_price), Number(this.newRoamingZone.group_3_sms_price), Number(this.newRoamingZone.group_4_sms_price), Number(this.newRoamingZone.group_5_sms_price), Number(this.newRoamingZone.incoming_call_price), Number(this.newRoamingZone.data_mb_price));
            if (zone_uuid == undefined || zone_uuid.length != 36) {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            }).then(() => {
                this.$forceUpdate();
                this.$router.push(`/secure/roaming`);
            });
        }
        this.HasLoading = false;
    }
};
RoamingZoneCreate = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], RoamingZoneCreate);
export default RoamingZoneCreate;
